<template>
  <div data-v-30cc7cf3="" class="contents">
    <div data-v-30cc7cf3="" class="header">
      <div data-v-30cc7cf3="" class="header-left">
        <div data-v-30cc7cf3="" class="header-txt" style="margin-left: 15px">
          {{ $t('aitrades') }}
        </div>
      </div>
    </div>
    <div data-v-30cc7cf3="" class="empty-box"></div>
    <div data-v-30cc7cf3="" class="contents-box" style="padding: 0px 20px">
      <div data-v-30cc7cf3="" class="contents-balance-box">
        <div data-v-30cc7cf3="" class="left-bg1"></div>
        <div data-v-30cc7cf3="" class="left-bg2"></div>
        <div data-v-30cc7cf3="" class="balance-title-box">
          <div data-v-30cc7cf3="" class="title-box-card">
            <img
              data-v-30cc7cf3=""
              src="../../assets/img/balance.0dce5020-d095e268.svg"
            />
          </div>
          <span data-v-30cc7cf3="" class="title-box-txt">
            {{ $t('aitrades') }}</span
          >
        </div>
        <div data-v-30cc7cf3="" class="banalce-info">
          $ {{ userinfo.lcmoney }}
          <span data-v-30cc7cf3="">{{ userinfo.lcrates }} %</span>
        </div>
        <div data-v-30cc7cf3="" class="balance-infos">
          <div data-v-30cc7cf3="" class="balance-info">
            <div data-v-30cc7cf3="" class="balance-info-title">
              {{ $t('todayprof') }}
            </div>
            <div data-v-30cc7cf3="" class="balance-info-content">
              ${{ userinfo.aiprofit }}
            </div>
          </div>
          <div data-v-30cc7cf3="" class="balance-info">
            <div data-v-30cc7cf3="" class="balance-info-title">
              {{ $t('zongprofits') }}
            </div>
            <div data-v-30cc7cf3="" class="balance-info-content">
              ${{ userinfo.allprofit }}
            </div>
          </div>
          <div data-v-30cc7cf3="" class="balance-info"></div>
        </div>
        <div data-v-30cc7cf3="" class="big-buttons">
          <div data-v-30cc7cf3="" class="buttons-item">
            <div data-v-30cc7cf3="" class="button-item-icon">
              <img
                data-v-30cc7cf3=""
                src="../../assets/img/strategy_icon1.386857a4-6d613ebe.svg"
                alt=""
              />
            </div>
            <div data-v-30cc7cf3="" class="button-item-name">
              {{ $t('zijinsafe') }}
            </div>
          </div>
          <div data-v-30cc7cf3="" class="buttons-item">
            <div data-v-30cc7cf3="" class="button-item-icon">
              <img
                data-v-30cc7cf3=""
                src="../../assets/img/strategy_icon2.176fcbb7-a1adbde5.svg"
                alt=""
              />
            </div>
            <div data-v-30cc7cf3="" class="button-item-name">
              {{ $t('sywendi') }}
            </div>
          </div>
          <div data-v-30cc7cf3="" class="buttons-item">
            <div data-v-30cc7cf3="" class="button-item-icon">
              <img
                data-v-30cc7cf3=""
                src="../../assets/img/strategy_icon3.c4093d50-1c6bc327.svg"
                alt=""
              />
            </div>
            <div data-v-30cc7cf3="" class="button-item-name">
              {{ $t('czjiandan') }}
            </div>
          </div>
        </div>
        <div
          data-v-d3816564=""
          class="explain"
          :class="shoemore ? 'explain1' : ''"
        >
          <p data-v-d3816564="" @click="showexp = shoemore = true">
            {{ $t('aimore') }}
          </p>
          <span
            data-v-d3816564=""
            v-if="showexp"
            @click="shoemore = showexp = false"
            >{{ $t('zhankaim') }}</span
          >
        </div>
      </div>
      <div
        data-v-30cc7cf3=""
        class="new-create"
        style="padding: 20px 20px 30px"
      >
        <div data-v-30cc7cf3="" class="new-create-title">
          <span data-v-e6db21c0="" style="color: rgb(255, 255, 255);float: left;">{{ $t('cjallh') }}</span>
<!--          <div style="width: 100px;border: 1px solid white;"></div>-->
          <span data-v-e6db21c0="" style="font-weight: 400;font-size: 14px;opacity: 0.3;color: #fff;float: right;" @click="gopage('/strategyOrder')">{{ $t('historys') }}</span>
        </div>
        <div data-v-30cc7cf3="" class="new-create-input-list">
          <div data-v-30cc7cf3="" class="inputs inputs-max">
            <div data-v-30cc7cf3="" class="new-create-lable">
              {{ $t('qixians') }}
            </div>
            <div data-v-30cc7cf3="" class="new-create-input-content">
              <span @click="open1" style="padding: 0 40% 0 0">
                {{ list[dayindex]['cycle'] }}</span
              >
              <img
                data-v-30cc7cf3=""
                src="../../assets/img/arrow_up.4af92010-da9ef403.svg"
                v-if="showlist"
                @click="showlist = false"
              /><img
                data-v-30cc7cf3=""
                src="../../assets/img/arrow_down.36c10fef-74a57df6.svg"
                v-else
                @click="showlist = true"
              />
              <div data-v-30cc7cf3="" class="day-lists" v-if="showlist">
                <div
                  data-v-30cc7cf3=""
                  class="day-list"
                  v-for="(item, index) in list"
                  @click="selectday(index)"
                >
                  <div data-v-30cc7cf3="">
                    {{ item.cycle }} {{ $t('tian') }}
                  </div>
                  <div data-v-30cc7cf3="">
                    {{ item.min_rates }}-{{ item.max_rates }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-v-30cc7cf3="" class="new-create-input-list">
          <div data-v-30cc7cf3="" class="inputs inputs-max">
            <div data-v-30cc7cf3="" class="new-create-lable">
              {{ $t('amountt') }}
            </div>
            <div
              data-v-30cc7cf3=""
              class="new-create-input-content input-content1"
            >
              <input
                data-v-30cc7cf3=""
                class="money-input"
                type="text"
                placeholder="0"
                v-model="amount"
                onchange="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                onkeyup="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                onafterpaste="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
                style="width: 100%"
              />
            </div>
          </div>
        </div>
        <div data-v-30cc7cf3="" class="new-create-infos">
          <div data-v-30cc7cf3="" class="new-create-info">
            <div data-v-30cc7cf3="" class="new-create-info-title">
              {{ $t('roi') }}
            </div>
            <div data-v-30cc7cf3="" class="new-create-info-content">
              {{ list[dayindex]['min_rates'] }}-{{
                list[dayindex]['max_rates']
              }}%
            </div>
          </div>
          <div data-v-30cc7cf3="" class="new-create-info">
            <div data-v-30cc7cf3="" class="new-create-info-title">
              {{ $t('edudud') }}
            </div>
            <div data-v-30cc7cf3="" class="new-create-info-content">
              {{ list[dayindex]['min_invest'] }}-{{
                list[dayindex]['max_invest']
              }}
            </div>
          </div>
        </div>
        <div
          data-v-30cc7cf3=""
          class="new-create-confirm-button"
          @click="beforesub"
        >
          {{ $t('confirm') }}
        </div>
      </div>
      <div data-v-30cc7cf3="" class="model-mian" v-if="showcon">
        <div data-v-30cc7cf3="" class="model-content">
          <div data-v-30cc7cf3="" class="icon">
            <img
              data-v-30cc7cf3=""
              src="../../assets/img/trading.60cebfaa-71c912fd.svg"
              alt=""
            />
          </div>
          <div data-v-30cc7cf3="" class="titles">
            {{ $t('confirorder') }}
            <div data-v-30cc7cf3="" class="titles-info">
              {{ $t('cjdingdanzh') }}
            </div>
          </div>
          <div data-v-30cc7cf3="" class="hr"></div>
          <div data-v-30cc7cf3="" class="list">
            <div data-v-30cc7cf3="" class="lable">{{ $t('amountt') }}</div>
            <div data-v-30cc7cf3="" class="number">${{ amount }}</div>
          </div>
          <div data-v-30cc7cf3="" class="list">
            <div data-v-30cc7cf3="" class="lable">{{ $t('qixians') }}</div>
            <div data-v-30cc7cf3="" class="number">
              {{ list[dayindex]['cycle'] }} {{ $t('tian') }}
            </div>
          </div>
          <div data-v-30cc7cf3="" class="list">
            <div data-v-30cc7cf3="" class="lable">{{ $t('roi') }}</div>
            <div data-v-30cc7cf3="" class="number">
              {{ list[dayindex]['min_rates'] }}-{{
                list[dayindex]['max_rates']
              }}%
            </div>
          </div>
          <div data-v-30cc7cf3="" class="confirm-button" @click="submit">
            {{ $t('confirm') }}
          </div>
        </div>
      </div>
    </div>
    <div data-v-30cc7cf3="" class="empty-box" style="height: 160px"></div>
    <div data-v-30cc7cf3="" class="loadingbox" style="display: none"></div>
  </div>
</template>

<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
export default {
  data() {
    return {
      list: [],
      info: {},
      showlist: false,
      amount: '',
      userinfo: [],
      dayindex: 0,
      showcon: false,
      shoemore: true,
      showexp: true,
    }
  },
  created() {
    this.getlist()
    this.getuserinfo()
  },
  methods: {
    async getlist() {
      const { data } = await this.$http.post('/strategylist')
      if (data) {
        if (data.code === '200') {
          this.list = data.data
        }
      }
    },
    async getuserinfo() {
      const { data } = await this.$http.post('/getuserinformation')
      if (data) {
        if (data.code === '200') {
          this.userinfo = data.data
        }
      }
    },

    beforesub() {
      if (!this.amount) {
        this.$toast.fail(this.$t('inputorderamount'))
        return false
      }
      let minnu = parseFloat(this.list[this.dayindex]['min_invest'])
      let maxnu = parseFloat(this.list[this.dayindex]['max_invest'])
      if (parseFloat(this.amount) < minnu || parseFloat(this.amount) > maxnu) {
        this.$toast.fail(this.$t('xiane'))
        return false
      }
      this.showcon = true
    },
    async submit() {
      const { data } = await this.$http.post('/createstrategyorder', {
        amount: this.amount,
        sid: this.list[this.dayindex]['id'],
      })
      if (data) {
        if (data.code === 200) {
          this.$toast.success(this.$t('success'))
          this.showcon = false
          return false
        }
        if (data.code === 405) {
          this.$toast.fail(this.$t('banlancebz'))
        }
      }
    },
    selectday(i) {
      this.showlist = false
      this.dayindex = i
      console.log(this.showlist)
    },
    open1() {
      if (this.showlist) {
        this.showlist = false
      } else {
        this.showlist = true
      }
    },
    // 产品介绍页
    tointroduction() {
      this.$router.push('/fund/introduction')
    },
    // 投资发布页
    toinvestment() {
      this.$router.push('/fund/investment')
    },
    // 投资标池页
    topool() {
      this.$router.push('/fund/pool')
    },
    todetail(id) {
      this.$router.push('/fund/investment/detail/' + id)
    },
    // 兑换
    gopage(p) {
      this.$router.push(p)
    },
  },
}
</script>

<style lang="less" scoped>
.maincontent {
  padding: 60px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-size: 0.93333rem;
  background: #f7f7f7;
  // 轮播图
  .first-swipe {
    height: 11rem;
    .van-swipe-item img {
      width: 94%;
    }
  }
  // 三个图标
  .icon-tiaozhuan {
    background-color: #fff;
    color: #000;
    height: 6.13333rem;
    .head-icon {
      border-top: 0.02667rem solid #232b40;
      padding-top: 0.93333rem;
    }
    .head-title {
      span {
        font-size: 0.93333rem;
        margin-top: 0.2rem;
      }
    }
    .head-icon div,
    .head-title div {
      display: flex;
      justify-content: center;
    }
  }
  // 发布
  .publish {
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
    background-color: #f7f7f7;
    display: flex;
    justify-content: center;
    .publish-rate {
      font-size: 2.66667rem;
      color: #00d25d;
      margin-top: 0.53333rem;
    }
    .publish-msg {
      margin-top: 0.53333rem;
      color: grey;
      font-size: 0.8rem;
    }
    .submitBtn {
      margin-top: 5%;
      width: 70%;
      letter-spacing: 0.53333rem;
      height: 3.2rem;
      font-size: 0.93333rem;
      color: #fff;
      background-color: #004ea3;
      border-radius: 0.53333rem;
      border: none;
      box-shadow: 0 0 1.33333rem #004ea3;
    }
  }
  // 发布列表
  /deep/.van-tabs__nav--line {
    box-sizing: initial;
    height: 100%;
    padding-bottom: 15px;
  }
  /deep/.van-tab {
    font-size: 1rem;
  }
  /deep/.van-tab--active {
    color: #004ea3;
  }
  .details-data {
    padding: 0.8rem 1.06667rem;
    text-align: left;
    line-height: 1.6rem;
    border-top: 0.01rem solid #dcdcdc;
    background: #fff;
    h4 {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.explain[data-v-d3816564] {
  margin-top: 0.24em;
  font-weight: 400;
  font-size: 1em;
  color: hsla(0, 0%, 100%, 0.5);
  line-break: 0.2em;
  position: relative;
  margin-top: 20px;
}
.explain1 p[data-v-d3816564] {
  height: 2.5em;
  overflow: hidden;
}
.explain span[data-v-d3816564] {
  position: absolute;
  color: #fff;
  right: 1em;
  top: 1em;
  height: 2em;
  line-height: 2em;
  background: #1a1a1a;
  padding-left: 0.5em;
}
</style>
